export default __webpack_public_path__ + "static/media/flite.f006d412.jpg";